import { useEffect } from 'react';
import { useNavbar } from '@app/atoms/app/navbar.atom.ts';
import { Icon } from '@iconify/react';
import { Button } from '@heroui/react';
import { useNavigate, useParams } from 'react-router-dom';

export const CheckoutSuccessPage = () => {
  const set = useNavbar();
  const { orderId } = useParams<{ orderId: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    set.none();
  }, []);
  return (
    <div className="flex flex-col items-center h-[calc(100vh-74px)] justify-center lg:max-w-[680px] lg:mx-auto">
      <Icon
        icon="solar:verified-check-linear"
        className="w-16 h-16 lg:w-24 lg:h-24 text-[#17C964]"
      />

      <p className="text-lg lg:text-2xl font-semibold text-[#222222] mt-9">
        Заказ успешно оформлен
      </p>

      <p className="text-sm lg:text-base text-[#60656C] mt-3 text-center px-4">
        Мы уже начали собирать ваш заказ. Скоро вы получите уведомление о
        готовности.
      </p>

      <div className="flex flex-col w-full mt-9 gap-y-4 lg:flex-row gap-x-4">
        <Button
          size="lg"
          fullWidth
          color="primary"
          onPress={() => navigate(`/orders/${orderId}`)}
        >
          К заказу
        </Button>

        <Button
          size="lg"
          variant="bordered"
          fullWidth
          color="primary"
          onPress={() => navigate('/')}
        >
          На главную
        </Button>
      </div>
    </div>
  );
};
